module.exports = __webpack_public_path__ + "static/businessHeader-22cb1b2b9de65147d73d47b6ee85a173.jpg";